import { FONT_FAMILY_DISPLAY, FONT_FAMILY_TEXT } from "./constants";

const fontFamily = {
    display: `var(--font-family-display, ${FONT_FAMILY_DISPLAY})`,
    text: `var(--font-family-text, ${FONT_FAMILY_TEXT})`
};

export const theme = {
    fontFamily
};
